import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { BaseXYAxisChartOptions, MetaInfoOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { HyperSpaceColumnChartWidgetOptions } from './types';
import { observable } from 'mobx';

export class HyperSpaceColumnChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceColumnChartWidgetOptions {
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        grid: {
            enabled: false,
        },
        yAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
            label: {
                enabled: true,
                size: 50,
            },
        },
        xAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
            label: {
                enabled: true,
                size: 50,
            },
        },
    };
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
    @observable columnWidth = 90;
}
